const listUsers = async () => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", localStorage.getItem("token"));

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  return fetch(`${process.env.REACT_APP_API_URL}/list_users`, requestOptions)
    .then((result) => {
      return result.json();
    })
    .catch((error) => {throw new Error(error)});
};

export default listUsers;
